import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 2,
  class: "table table-hover table-bordered"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = ["disabled"]

import { computed } from 'vue'

    import type { ScoresExporterAlternativeReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels'
    import { ScoresExporterViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoresExporter'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScoresExporter',
  props: {
    viewModel: {}
  },
  emits: ["close-dialog", "export-scores", "reset-preview", "load-preview", "show-attribute-creator"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- derived ---------------- */

    const MappedAttributeIds = computed<number[]>(() =>
        vm.value.criteria
            .filter(c => c.AttributeId != null)
            .map(c => c.AttributeId)
    )

    /* ---------------- helpers ---------------- */

    function IsExact(alternative: ScoresExporterAlternativeReadModel, attrId: number): boolean
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).IsExact
    }

    function HasValue(alternative: ScoresExporterAlternativeReadModel, attrId: number): boolean
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).AttributeValue != null
    }

    function HasDefinedAttributeValues(alternative: ScoresExporterAlternativeReadModel, attrId: number): boolean
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).HasDefinedAttributeValues
    }

    function getScore(alternative: ScoresExporterAlternativeReadModel, attrId: number): number
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).Score
    }

    function getAttributeValue(alternative: ScoresExporterAlternativeReadModel, attrId: number): number
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).AttributeValue
    }

    function getAttributeValueLabel(alternative: ScoresExporterAlternativeReadModel, attrId: number): string
    {
        return alternative.Scores.find(s => s.AttributeId === attrId).AttributeValueLabel
    }

    function getAttributeName(attrId: number): string
    {
        return vm.value.attributes.find(a => a.Id === attrId).Name
    }

    /* ---------------- actions ---------------- */

    function close()
    {
        emit('close-dialog')
    }

    function exportScores()
    {
        const mappings = vm.value.criteria
            .filter(c => c.AttributeId != null)
            .map(c => ({
                RefCriterionId: c.Id,
                AttributeId: c.AttributeId
            }))

        emit('export-scores', mappings)
    }

    function resetPreview()
    {
        emit('reset-preview')
    }

    function loadPreview()
    {
        const mappings = vm.value.criteria
            .filter(c => c.AttributeId != null)
            .map(c => ({
                RefCriterionId: c.Id,
                AttributeId: c.AttributeId
            }))

        emit('load-preview', mappings)
    }

    function createAttribute()
    {
        emit('show-attribute-creator')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Save scores to attributes", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (vm.value.initialized === false)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : (vm.value.initialized === true && vm.value.preview == null)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                        _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Criterion"),
                            _createElementVNode("th", null, "Attribute")
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.value.criteria, (c) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: c.Id
                            }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(c.Name) + " ", 1 /* TEXT */),
                                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(c.Path), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((c.AttributeId) = $event)
                                }, [
                                  _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.value.attributes, (attr) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: attr.Id,
                                      value: attr.Id
                                    }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_9), [
                                  [_vModelSelect, c.AttributeId]
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : (vm.value.initialized === true && vm.value.preview != null)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Alternative", -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(MappedAttributeIds.value, (attrId) => {
                                return (_openBlock(), _createElementBlock("th", { key: attrId }, _toDisplayString(getAttributeName(attrId)), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.value.alternatives, (alternative) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: alternative.Name
                              }, [
                                _createElementVNode("td", null, _toDisplayString(alternative.Name), 1 /* TEXT */),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(MappedAttributeIds.value, (attrId) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: attrId,
                                    class: _normalizeClass({'bg-warning': IsExact(alternative, attrId) === false})
                                  }, [
                                    (HasValue(alternative, attrId))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          (HasDefinedAttributeValues(alternative, attrId) === false)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(getScore(alternative, attrId)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                          (HasDefinedAttributeValues(alternative, attrId) === true)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(getAttributeValueLabel(alternative, attrId)) + " (" + _toDisplayString(getAttributeValue(alternative, attrId)) + ") ", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                          (IsExact(alternative, attrId) === false)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                                _createTextVNode("Source score: " + _toDisplayString(getScore(alternative, attrId)), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 2 /* CLASS */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (vm.value.preview == null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: createAttribute,
                        class: "btn btn-outline-secondary"
                      }, "New attribute"),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: loadPreview,
                        disabled: MappedAttributeIds.value.length == 0,
                        class: "btn btn-primary"
                      }, "Preview", 8 /* PROPS */, _hoisted_17)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: resetPreview,
                        class: "btn btn-outline-secondary"
                      }, "Back"),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: exportScores,
                        class: "btn btn-success"
                      }, "Save")
                    ], 64 /* STABLE_FRAGMENT */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})